import AccountRecoveryErrorModal from './AccountRecoveryErrorModal';

export default AccountRecoveryErrorModal;
